import React from "react";
import ListUsers from "./List";
import AddUser from "./Add";
import ChangePassword from "./ChangePassword";
import UsersAdministrationHelp from "./Help";
import View from "common/View";

const options = [
  {
    signal: "add-user",
    label: "Add User",
  },
];

export const UsersAdmin = () => (
  <View
    title="Available Users"
    className="container-lg"
    Help={UsersAdministrationHelp}
    options={options}
  >
    <ListUsers />
    <AddUser />
    <ChangePassword />
  </View>
);

export default UsersAdmin;
